// extracted by mini-css-extract-plugin
export default {"content":"AddAgreement_content__muBmz"};